export interface BrochureRequestPayload {
  solutionTitle: string;
  solutionDescription: string;
  countryCode: string;
  phoneNumber: string;
  email: string;
}

const BROCHURE_API_URL = process.env.REACT_APP_BROCHURE_API_URL || 'http://localhost:5002';

export const requestBrochure = async (payload: BrochureRequestPayload) => {
  const response = await fetch(`${BROCHURE_API_URL}/api/brochure-request`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'omit',
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.message || 'Failed to submit brochure request');
  }

  return response.json();
};
